import React, { useEffect } from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import BackupImage from '../images/coming-soon.jpg';

type Props = {
	teamMembers: any[];
	activeMemberName: string;
	closeTeamOverlay: () => void;
	changeActiveOverlayMember: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

const TeamOverlay = ({ teamMembers, activeMemberName, closeTeamOverlay, changeActiveOverlayMember }: Props) => {
	useEffect(() => {
		// Disable scrolling
		document.body.style.overflow = 'hidden';

		// Re-enable scrolling when the component unmounts
		return () => {
			document.body.style.overflow = 'unset';
		};
	}, []);

	const activeMember = teamMembers.find(member => member.name === activeMemberName),
		activeIndex = teamMembers.map(m => m.name).indexOf(activeMember.name),
		nameSplit = activeMember.name.split(' ');

	const prevMember = teamMembers.find((member, i) => i === activeIndex - 1),
		nextMember = teamMembers.find((member, i) => i === activeIndex + 1);

	const activeMemberImage = activeMember.altImage ? getImage(activeMember.altImage) : activeMember.image ? getImage(activeMember.image) : null;

	return (
		<div id="team-overlay">
			<div className="content">
				<div className="content-copy">
					<div className="exit-container" onClick={closeTeamOverlay} role="button" onKeyPress={() => {}} tabIndex={0}>
						<div className="exit"></div>
					</div>
					<div className="head">
						<div>{activeMemberImage ? <GatsbyImage image={activeMemberImage} alt={activeMember.name} /> : <img src={BackupImage} alt={activeMember.name} />}</div>
						<div>
							<h3>
								{nameSplit[0]} <br />
								{nameSplit[1]}
							</h3>
							<p className="subtitle">{activeMember.title}</p>
						</div>
					</div>
					<p className="bio">{activeMember.bio.bio}</p>
				</div>
				{(prevMember || nextMember) && (
					<div className="arrow-controls">
						{prevMember && (
							<div className="prev" onClick={changeActiveOverlayMember} title={prevMember.name}>
								<div>
									<i></i>
								</div>
								<div>
									<p>{prevMember.name}</p>
									<p className="title">{prevMember.title}</p>
								</div>
							</div>
						)}
						{nextMember && (
							<div className="next" onClick={changeActiveOverlayMember} title={nextMember.name}>
								<div>
									<p>{nextMember.name}</p>
									<p className="title">{nextMember.title}</p>
								</div>
								<div>
									<i></i>
								</div>
							</div>
						)}
					</div>
				)}
			</div>
		</div>
	);
};

export default TeamOverlay;
